import { restaurant, images } from "../data";
import { Phone, MapPin, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer id="contact" data-testid="site-footer" className="relative z-10 bg-[#0f0f0f] pt-20 pb-10">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="rounded-3xl bg-gradient-to-br from-[#1a1a1a] to-[#141414] border border-white/10 p-10 md:p-14 text-center">
          <span className="font-script text-3xl text-[#eab308]">Guten Appetit!</span>
          <h2 className="mt-2 font-display font-black text-4xl md:text-6xl text-[#f5f5f0] leading-tight">
            Lust auf <span className="text-[#e05d36]">Döner</span> oder <span className="text-[#eab308]">Pizza</span>?
          </h2>
          <p className="mt-4 text-[#a3a3a3] text-lg max-w-xl mx-auto">
            Ruf einfach an – wir bereiten deine Bestellung frisch zu. Abholung oder Lieferung nach Hause.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <a
              href={restaurant.phoneHref}
              data-testid="footer-call-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#e05d36] hover:bg-[#c94925] text-black font-bold px-8 py-4 transition-[transform,background-color] duration-200 hover:-translate-y-1"
            >
              <Phone size={20} strokeWidth={2.5} /> {restaurant.phone}
            </a>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-8 border-t border-white/10 pt-10">
          <div>
            <div className="flex items-center gap-3">
              <img src={images.logo} alt="Logo" width="56" height="56" className="h-14 w-14 flex-shrink-0 rounded-full object-cover ring-1 ring-[#eab308]/40" />
              <span className="font-display font-black text-lg text-[#f5f5f0]">Zum Goldenen Döner</span>
            </div>
            <p className="mt-4 text-sm text-[#a3a3a3] leading-relaxed">
              Dein Döner & Pizza Haus in Krefeld. Frische Zutaten, ehrliche Preise, seit Jahren beliebt.
            </p>
          </div>
          <div className="space-y-3 text-sm text-[#a3a3a3]">
            <p className="flex items-center gap-3"><MapPin size={16} className="text-[#e05d36]" /> {restaurant.address}</p>
            <p className="flex items-center gap-3"><Phone size={16} className="text-[#e05d36]" /> {restaurant.phone}</p>
            <p className="flex items-center gap-3"><Clock size={16} className="text-[#e05d36]" /> Täglich ab 11:00 Uhr</p>
          </div>
          <div className="text-sm">
            <h4 className="font-semibold text-[#f5f5f0]">Navigation</h4>
            <div className="mt-3 flex flex-col gap-2">
              <a href="#menu" className="text-[#a3a3a3] hover:text-[#e05d36] transition-colors duration-200">Speisekarte</a>
              <a href="#reviews" className="text-[#a3a3a3] hover:text-[#e05d36] transition-colors duration-200">Bewertungen</a>
              <a href="#info" className="text-[#a3a3a3] hover:text-[#e05d36] transition-colors duration-200">Öffnungszeiten</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 text-center text-xs text-[#666]">
          © {new Date().getFullYear()} Zum Goldenen Döner & Pizza Haus · Marktstraße 78, 47798 Krefeld
        </div>
      </div>
    </footer>
  );
}
